
import React, { createContext, useState, useRef, useEffect } from "react";
import { message } from "antd";

export const VoiceCommandContext = createContext();

export const VoiceCommandProvider = ({ children }) => {
  const [isListening, setIsListening] = useState(false);
  const [bpValue, setBpValue] = useState(null);
  const [searchPatientName, setSearchPatientName] = useState('');
  const [isConsultationNotesOpen, setIsConsultationNotesOpen] = useState(false);
  const recognitionRef = useRef(null);
  const isDictatingComplaintRef = useRef(false);
  const [chiefComplaintVoice, setChiefComplaintVoice] = useState("");
  const [symptomsVoice, setSymptomsVoice] = useState("");
  const [diseaseConditionVoice, setDiseaseConditionVoice] = useState("");
  const [icdCodeVoice, setIcdCodeVoice] = useState("");
  const [activeSection, setActiveSection] = useState("consultationNotes");
  const [liveChiefComplaint, setLiveChiefComplaint] = useState("");
  const [vitals, setVitals] = useState({
    systolic: "",
    diastolic: "",
    heartRate: "",
    temperature: "",
    spo2: "",
    rr: "",
    height: "",
    weight: "",

  });
  const [medicineData, setMedicineData] = useState({
    medicineName: "",
    composition: "",
    dosage: "",
    frequency: "",
    duration: "",
    quantity: "",
    timeTaken: "",
    notes: "",
  });
  const [medicineVoice, setMedicineVoice] = useState("");
  const [labTestVoice, setLabTestVoice] = useState("");
  const [treatmentPlanVoice, setTreatmentPlanVoice] = useState("");
  const [schedule, setSchedule] = useState();
  const [refillDate, setRefillDate] = useState();
  const [isPreviewModalOpen, setIsPreviewModal] = useState(false);
  const [medicalOpen, setMedicalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [commandType, setCommandType] = useState("");
  const [targetField, setTargetField] = useState("");
  const [commandValue, setCommandValue] = useState("");
  const [deleteDiagnosisVoice, setDeleteDiagnosisVoice] = useState('')
  const [deleteMedicineVoice, setDeleteMedicineVoice] = useState("")
  const [deleteLabTestVoice, setDeleteLabTestVoice] = useState("")
  const [isMicActive, setIsMicActive] = useState(false); 
  const [editMedicineVoice, setEditMedicineVoice] = useState("");
  const [selectAllVoice, setSelectAllVoice] = useState("");




  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      message.error("Speech Recognition not supported!");
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.lang = "en-US";
    recognition.interimResults = true;
    recognitionRef.current = recognition;
  }, []);


  return (
    <VoiceCommandContext.Provider
      value={{
        isListening,
        setIsListening,
        recognitionRef,
        isDictatingComplaintRef,
        bpValue,
        setBpValue,
        searchPatientName,
        setSearchPatientName,
        isConsultationNotesOpen,
        setIsConsultationNotesOpen,
        chiefComplaintVoice,
        setChiefComplaintVoice,
        symptomsVoice,
        setSymptomsVoice,
        diseaseConditionVoice,
        setDiseaseConditionVoice,
        icdCodeVoice,
        setIcdCodeVoice,
        activeSection,
        setActiveSection,
        liveChiefComplaint,
        setLiveChiefComplaint,
        vitals,
        setVitals,
        medicineData,
        setMedicineData,
        medicineVoice, setMedicineVoice,
        labTestVoice, setLabTestVoice,
        treatmentPlanVoice, setTreatmentPlanVoice,
        schedule, setSchedule,
        refillDate, setRefillDate,
        isPreviewModalOpen, setIsPreviewModal,
        medicalOpen, setMedicalOpen,
        selectedOption, setSelectedOption,
        commandType, setCommandType,
        targetField, setTargetField,
        commandValue, setCommandValue,
        deleteMedicineVoice, setDeleteMedicineVoice,
        deleteLabTestVoice, setDeleteLabTestVoice,
        deleteDiagnosisVoice, setDeleteDiagnosisVoice,
        isMicActive, setIsMicActive,
        editMedicineVoice, setEditMedicineVoice,
        selectAllVoice, setSelectAllVoice
      }}
    >
      {children}
    </VoiceCommandContext.Provider>
  );
};
